import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { BookingProvider } from "@/context/BookingContext";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/admin" element={<Admin />} />
          <Route
            path="*"
            element={
              <LanguageProvider>
                <BookingProvider>
                  <Home />
                  <Toaster position="bottom-center" richColors />
                </BookingProvider>
              </LanguageProvider>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
